module.exports = __webpack_public_path__ + "img/wobi1.9713eede.png";